var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.legalObject)?_c('div',{staticClass:"bcx-pointer",on:{"click":_vm.onClick}},[_c('h4',[_vm._v(_vm._s(_vm.$t('settings.legal.' + _vm.typeKey)))]),_c('p',[_vm._v(_vm._s(_vm.version))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }